
import { BaseBus } from './BaseBus';
import { CustomerInventoryPMBus } from './CustomerInventoryPMBus';
import { CustomerLocationPMBus } from './CustomerLocationPMBus';
import { GItem } from './GItem';
export class CustomerPmsBus extends BaseBus
{
    constructor(data: CustomerPmsBus = null) {
        super(data);
        
    }

    customerPmid: string;
    companyId: string;
    customerId: string;
    pmname: string;
    estHrs: number;
    price: number;
    sortOrder: number;
    classId: string;
    scheduleFrequencyId: string;
    startDate: Date;
    endDate: Date;
    insertDt: Date;
    insertUserId: string;
    updateDt: Date;
    updateUserId: string;
    note: string;

    locations: CustomerLocationPMBus[];
    allParts: CustomerInventoryPMBus[];
    changedParts: CustomerInventoryPMBus[];
    deletedParts: GItem[] = [];
}
